<template>
    <div class="user-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="user-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">用户列表</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">手机号</span>
                        <el-input placeholder="请输入手机号"
                                  v-model="selectForm.phone"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label">注册日期</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="searchQuery">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetQuery">重置</el-button>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="nickName"
                                     min-width="120px"
                                     label="昵称">
                    </el-table-column>
                    <el-table-column min-width="120px"
                                     label="性别">
                        <template slot-scope="{row}">
                            <span v-if="row.sex ==='MALE'">男</span>
                            <span v-else-if="row.sex === 'FEMALE'">女</span>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userName"
                                     min-width="120px"
                                     label="手机号">
                    </el-table-column>
                    <el-table-column prop="createTime"
                                     min-width="120px"
                                     label="注册日期">
                    </el-table-column>
                    <el-table-column label="操作"
                                     width="200px">
                        <template slot-scope="{row}">
                            <span @click="handleClick(row.iuid, 'view')"
                                  class="link-btn">查看</span>
                            <span class="link-btn"
                                  @click="handleClick(row.iuid, 'edit')">编辑</span>
                            <span class="link-btn"
                                  @click="changePassword(row)">修改密码</span>
                        </template>
                    </el-table-column>
                    <div slot="empty">
                        <table-empty />
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="passVisible"
                   top="20vh"
                   title="修改密码"
                   width="560px"
                   :close-on-click-modal="false"
                   class="patient-pass-dialog">
            <el-form :model="passForm"
                     ref="passForm"
                     label-width="70px"
                     :rules="passRules"
                     class="pass-passForm"
                     v-loading="passFormLoading">
                <el-form-item label="手机号">
                    <el-input v-model="passForm.phone"
                              disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="验证码"
                              prop="code"
                              :rules="[{ required: true, message: '请输入验证码', trigger: 'change'}, { required: true, message: '请输入验证码', trigger: 'blur'}]">
                    <el-input v-model="passForm.code"
                              placeholder="请输入验证码">
                    </el-input>
                    <div class="get-code"
                         :class="[{'click-code': codeCanClick}]"
                         @click="getCode">{{codeStr}}</div>
                </el-form-item>
                <el-form-item label="新密码"
                              prop="newPassword"
                              style="width: 400px;">
                    <el-popover placement="right-start"
                                width="236px"
                                popper-class="patient-userList-popover-hover"
                                trigger="hover">
                        <div class="pass-length">
                            <i class="el-icon-circle-check"
                               v-if="passShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">长度为8-32个字符</p>
                        </div>
                        <div class="pass-rule">
                            <i class="el-icon-circle-check"
                               v-if="ruleShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">数字、大小写字母以及特殊字符至少包含两种</p>
                        </div>
                        <el-input v-model="passForm.newPassword"
                                  slot="reference"
                                  type="password"
                                  maxlength="50"
                                  placeholder="请输入新密码">
                        </el-input>
                    </el-popover>
                </el-form-item>
                <el-form-item style="padding-bottom: 20px;">
                    <el-button type="primary"
                               class="commit-btn"
                               @click="handleCommitPass">确定</el-button>
                    <el-button class="cancle-btn"
                               @click="handleCancle">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { postAppUserList, postChangePassword, postSendVerification } from '@/api/patient/user'
export default {
    name: 'videoLibrary',
    data () {
        const checkPassword = (rule, value, callback) => {
            if (value === '') {
                this.passShow = false
                this.ruleShow = false
                callback(new Error('请输入新密码！'))
            } else {
                if (value.length > 32 || value.length < 8) {
                    this.passShow = false
                    callback(new Error('密码格式错误!'))
                } else {
                    this.passShow = true
                    // 判断密码强弱
                    let modes = this.checkPasswordStrong(value)
                    if (modes < 2) {
                        this.ruleShow = false
                        callback(new Error('密码格式错误!'))
                    } else {
                        this.ruleShow = true
                        callback()
                    }
                }
            }
        }
        return {
            loading: false,
            passVisible: false,
            breadList: [{ label: '用户管理' }, { label: '用户列表' }],
            dataList: [{}, {}],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            passForm: {
                code: '',
                phone: '',
                iuid: '',
                newPassword: ''
            },
            selectForm: {
                phone: '',
                createTime: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            timerInterval: null,
            passFormLoading: false,
            codeCanClick: true,
            passShow: false,
            ruleShow: false,
            codeStr: '获取验证码',
            passRules: {
                newPassword: [{ required: true, validator: checkPassword, trigger: 'change' }]
            }
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    methods: {
        // 点击修改密码
        changePassword (row) {
            this.passForm.phone = row.userName
            this.passForm.iuid = row.iuid
            this.passForm.newPassword = ''
            this.passForm.code = ''
            this.passVisible = true
            if (this.$refs['passForm']) {
                this.$refs['passForm'].resetFields()
            }
        },
        handleCancle () {
            this.passVisible = false
            clearInterval(this.timerInterval)
        },
        // 确定修改密码
        handleCommitPass () {
            this.$refs['passForm'].validate((valid) => {
                if (valid) {
                    this.handleSavePass()
                } else {
                    return false
                }
            })
        },
        async handleSavePass () {
            let params = {
                iuid: this.passForm.iuid,
                hospitalId: this.userInfo.hospitalId,
                password: this.passForm.newPassword,
                account: this.passForm.phone
            }
            this.passFormLoading = true
            const { results } = await postChangePassword(params, this.passForm.code, this.userInfo.phone)
            if (results === 'OK') {
                this.passVisible = false
                this.$message({
                    message: '成功修改密码！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
            }
            this.passFormLoading = false
        },
        // 获取验证码倒计时
        getCode () {
            if (!this.codeCanClick) {
                return
            }
            let timer = 60
            this.codeStr = timer + 's'
            this.codeCanClick = false
            this.timerInterval = setInterval(() => {
                timer--
                if (timer < 1) {
                    clearInterval(this.timerInterval)
                    this.codeCanClick = true
                    this.codeStr = '获取验证码'
                } else {
                    this.codeStr = timer + 's'
                }
            }, 1000)
            this.handleVerification()
        },
        async handleVerification () {
            let params = {
                phone: this.userInfo.phone,
                signName: '树兰医疗'
            }
            await postSendVerification(params)
        },
        // 判断密码强弱
        checkPasswordStrong (password) {
            let modes = 0
            if (/\d/.test(password)) { // 数字
                modes++
            }
            if (/[a-z]/.test(password) || /[A-Z]/.test(password)) { // 大小写
                modes++
            }
            if (/\W/.test(password)) { // 特殊字符
                modes++
            }
            return modes
        },
        // 编辑、查看
        handleClick (iuid, type) {
            this.$router.push({ path: '/patient/user/userDetails', query: { iuid: iuid, type: type } })
        },
        searchQuery () {
            this.query(1)
        },
        resetQuery () {
            this.selectForm.phone = ''
            this.selectForm.createTime = ''
            this.query(1)
        },
        handlePageChange (val) {
            this.query(val)
        },
        query (val) {
            this.page.current = val
            this.queryUserList()
        },
        async queryUserList () {
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }
            let params = {
                createEndTime: createTimeEnd,
                createStartTime: createTimeStart,
                hospitalId: this.userInfo.hospitalId,
                phone: this.selectForm.phone,
                size: this.page.pageSize,
                page: this.page.current
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postAppUserList(params)
            this.dataList = results
            this.page.total = total
            this.loading = false
        }
    },
    mounted () {
        this.queryUserList()
    },
    beforeRouteEnter (to, from, next) {
        console.log('userList', to, from, next)
        next()
    }
}
</script>

<style lang="scss">
.user-wrap {
    height: 100%;
    .user-content {
        height: calc(100% - 91px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}

.patient-pass-dialog {
    .el-dialog__body {
        .pass-passForm {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
            }
            .el-input {
                .el-input__inner {
                    background: #ffffff;
                    border: 1px solid #dcdcdc;
                    border-radius: 3px;
                    width: 330px;
                    height: 32px;
                    padding: 5px 10px;
                }
            }
            .commit-btn {
                width: 100px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 4px;
                padding: 0;
            }
            .cancle-btn {
                width: 100px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #666;
                letter-spacing: 4px;
                padding: 0;
                border: 1px solid #dbdbdb;
            }
        }

        .get-code {
            position: absolute;
            top: 1px;
            right: 121px;
            height: 30px;
            line-height: 30px;
            width: 100px;
            text-align: center;
            border-left: 1px solid #dcdcdc;
            background: #f6f6f6;
            color: #999999;
            font-size: 14px;
            cursor: not-allowed;
            border-radius: 3px;
        }
        .click-code {
            background: #fff;
            color: #666;
            cursor: pointer;
        }
        .el-input__suffix {
            .el-input__icon {
                line-height: 32px;
            }
        }
    }
}

.patient-userList-popover-hover {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    .pass-length {
        display: flex;
        align-items: center;
        height: 20px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
        }
    }
    .pass-rule {
        display: flex;
        align-items: flex-start;
        height: 20px;
        padding-bottom: 14px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
            margin-top: 3px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
            margin-top: 3px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
            line-height: 18px;
        }
    }
}
</style>
